import React, { Suspense, lazy } from 'react';
import { Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import Packages from './pages/Packages';
import Header from './components/Header';
import Footer from './components/Footer';
import ContactSection from './components/ContactSection';
import SubServicePage from './pages/SubServicePage';
import Service from './pages/Service'
import Gallery from './pages/Gallery'
import AboutUs from './pages/AboutUs';
import ChannelPartner from './pages/ChannelPartner';
import Contact from './pages/Contact';
import GoToTop from './components/GoToTop';
import ScrollToTop from './components/ScrollToTop';
import Product from './pages/Product';
import Blogs from './pages/Blog';
import BlogDet from './pages/Blogdetail'
import './App.css';

const PrivacyPolicy = lazy(() => import('./pages/PrivacyPolicy'));
const TermsAndConditions = lazy(() => import('./pages/TermsAndConditions'));
const NotFound = lazy(() => import('./pages/NotFound'));

const App = () => {
  return (
    <div>
      <ScrollToTop />
      <Suspense fallback={<div style={{textAlign: 'center', marginTop: 60}}>Loading...</div>}>
        <Header/>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/packages" element={<Packages />} />
          <Route path="/services/:serviceSlug" element={<SubServicePage />} />
          <Route path="/about" element={<AboutUs />} />
          <Route path="/service" element={<Service />} />      
          <Route path="/gallery" element={<Gallery />} />       
          <Route path="/channelPartner" element={<ChannelPartner />} /> 
          <Route path="/product" element={<Product />} /> 
           <Route path="/Blogs" element={<Blogs />} />
          <Route path="/blog-details" element={<BlogDet />} />
          <Route path="/contact" element={<Contact />} />   
          <Route path="/privacypolicy" element={<PrivacyPolicy />} />
          <Route path="/terms" element={<TermsAndConditions />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
        <ContactSection/>
        <Footer/>
      </Suspense>
      <GoToTop />
    </div>
  )
}

export default App